"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = flexCenterColumn;
function flexCenterColumn() {
  return /*css*/"\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n  ";
}